var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReason(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.53009 15H5.54165M1.15558 3.69689C1.78059 2.12753 3.50308 1 5.53009 1C8.08463 1 10.1556 2.79086 10.1556 5C10.1556 6.6565 8.99123 8.0778 7.33172 8.6852C6.47508 8.9988 6.04676 9.1556 5.89689 9.2767C5.71846 9.4209 5.68458 9.4651 5.60063 9.6634C5.53009 9.8299 5.53009 10.0866 5.53009 10.6V12",
    stroke: "#D81F1F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReason);
export default __webpack_public_path__ + "static/media/reason.b2219bf1b2561b9e9a6cd87cf6abac09.svg";
export { ForwardRef as ReactComponent };